import React from 'react';
import { Button } from '@mui/material';

/**
 * High-visibility button. Use variant="light" on dark/gradient backgrounds.
 * Default is a solid teal button (visible on white AND light backgrounds).
 */
export default function GradientButton({ children, variant = 'default', sx = {}, ...props }) {
  const styles = {
    default: {
      bgcolor: '#1ebec8',
      color: '#fff',
      '&:hover': { bgcolor: '#17a8b1', boxShadow: '0 6px 20px rgba(30,190,200,0.3)' },
    },
    light: {
      bgcolor: '#fff',
      color: '#1a2332',
      '&:hover': { bgcolor: '#f5f5f5', boxShadow: '0 6px 20px rgba(0,0,0,0.15)' },
    },
    outlined: {
      bgcolor: 'transparent',
      color: '#1ebec8',
      border: '2px solid #1ebec8',
      '&:hover': { bgcolor: 'rgba(30,190,200,0.06)' },
    },
  };

  return (
    <Button
      variant="contained"
      disableElevation
      sx={{
        fontWeight: 600,
        px: 4,
        py: 1.5,
        borderRadius: '10px',
        textTransform: 'none',
        fontSize: '0.9rem',
        transition: 'all 0.2s ease',
        '&:active': { transform: 'scale(0.97)' },
        ...styles[variant],
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
